<template>
  <div class="onboarding-overlay pa-2">
    <div
      class="f-center clr-greys"
      style="position: absolute !important; left: 2rem; top: 1.25rem"
    >
      <div
        class="gw-icon-gwizlogo line-height_1 clr-primary"
        style="font-size: 2rem"
      ></div>
      <div class="weight_700 text-semi-large text-nowrap font-eina02 ml-2">GTO Wizard</div>
    </div>

    <PlaymentSlotWrapper
      style="position: absolute; top: 1rem; min-width: clamp(1px, 37.25rem, calc(100vw - 2rem)"
    >
      <template #default="{ anyCheapPlan }">
        <AffiliateMessage
          v-if="anyCheapPlan.discount"
          class="anim-fade-in_super-slow"
          :cheapPlan="anyCheapPlan"
        >
          <div
            class="ml-2 gw_btn gw_btn_text"
            style="--clr-back: rgba(255, 184, 0, 0.125); color: var(--clr-white-0)"
            @click="
              $router.push({
                name: 'SubscriptionPaymentSelection',
              })
            "
          >
            {{ $t('btn.upgrade_now') }}
          </div>
        </AffiliateMessage>
      </template>
    </PlaymentSlotWrapper>

    <LangMenu :onTopRight="true" />

    <transition-group
      tag="div"
      class="step_1 f-center position-relative w-100"
      name="slideslow"
      mode="out-in"
    >
      <div
        v-show="step === 1"
        key="a5"
        class="step_1 f-column position-absolute w-100"
      >
        <div class="ma-auto">
          <div class="f-column f-center text-center">
            <div class="text-ultra weight_600 mt-4">
              {{ $t('onboarding.welcome') }}
            </div>
            <div class="text-normal-large clr-grey weight_500 mt-2 anim-fade-in_super-slow mb-12">
              {{ $t('onboarding.select_format_tra01') }}
            </div>
          </div>
          <GmfGroupsSelektor
            class="anim-fade-in_slow"
            :namespace="''"
            @group:update="handleSelectedFormat"
          />
          <div class="text-medium clr-grey weight_400 mt-6 f-center">
            <div class="mdi mdi-information mr-1"></div>
            {{ $t('onboarding.dont_worry_gmf_change') }}
          </div>
        </div>
      </div>
      <div
        v-show="step === 2"
        key="a1"
        class="step_2 f-column position-absolute w-100"
      >
        <div class="f-column">
          <div class="ma-auto text-center">
            <div class="text-big weight_600 mt-4 mb-12">
              {{ $t('onboarding.what_to_do') }}
            </div>
          </div>

          <div class="grpc_grid mx-auto">
            <div
              v-for="(option, idx) in options"
              :key="option.pathName + idx"
              v-ripple
              class="grpc_btn anim-fade-in_slow"
              :data-tst="`path_${option.pathName}`"
              @click="handleClick(option)"
            >
              <div class="d-flex">
                <div
                  class="grpc_icon mdi"
                  :class="option.icon"
                ></div>
              </div>
              <div class="f-column grpc_title-box">
                <div class="grpc_title">
                  {{ option.text }}
                </div>
                <div class="grpc_subtitle clr-grey">
                  {{ option.sub }}
                </div>
              </div>
            </div>
          </div>
          <div class="text-medium clr-grey weight_400 mt-6 f-center">
            <div class="mdi mdi-information mr-1"></div>
            {{ $t('onboarding.dont_worry_features') }}
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import GmfGroupsSelektor from '@/components/GameFormat/GmfGroupsSelektor'
import { gtm_onboarding } from '@/helpers/gtm'
import LangMenu from '@/components/LangSwitcher/LangMenu'
import PlaymentSlotWrapper from '@/components/Payments/PlaymentSlotWrapper'
import AffiliateMessage from '@/components/Payments/AffiliateMessage'

export default {
  name: 'OnboardingOverlay',
  components: {
    GmfGroupsSelektor,
    LangMenu,
    AffiliateMessage,
    PlaymentSlotWrapper,
  },
  data() {
    return {
      step: 1,
      selectedGroup: null,
    }
  },
  created() {
    localStorage.removeItem('StudySolutions')
    localStorage.removeItem('tra/alpha')
  },
  methods: {
    handleSelectedFormat(group) {
      this.selectedGroup = group.id
      this.step = 2
    },
    handleClick(option) {
      const { user_info } = this.$store.getters

      if (user_info.is_new) {
        gtm_onboarding({
          game: this.selectedGroup.toUpperCase(),
          mode: option.gtm_mode,
        })
        this.$store.dispatch('setUserInfo', { ...user_info, is_new: false })
      }
      if (option.fn) {
        option.fn()
      }
      this.$router.push({
        name: option.pathName,
        query: {
          ...this.$route.query,
          ...(option.query || {}),
        },
      })
    },
    // getFntSize(str) {
    //   let num = str.length > 100 ? 0.8 : 1
    //   return `font-size:${num}rem`
    // },
  },
  computed: {
    options() {
      return [
        {
          icon: 'mdi-school',
          sub: this.$t('onboarding.sub_solution', {
            num: `${(10000000).toLocaleString(this.$i18n.locale)}+`,
          }),
          text: this.$t('onboarding.browse'),
          pathName: 'StudySolutions',
          gtm_mode: 'StudySolutions',
          query: { soltab: 'strategy' },
          fn: () => {
            this.$store.dispatch('router_update_query', {
              query: { soltab: 'strategy' },
              push: false,
            })
          },
        },
        {
          icon: 'mdi-motion-play-outline',
          sub: this.$t('onboarding.sub_practice'),
          text: this.$t('onboarding.practice'),
          pathName: 'PracticeTrainer',
          gtm_mode: 'PracticeTrainer',
        },
        {
          icon: 'mdi-cards-playing',
          sub: this.$t('onboarding.sub_analyze'),
          text: this.$t('onboarding.analyze'),
          pathName: 'AnalyzeOriginal',
          gtm_mode: 'AnalyzeOriginal',
        },
        {
          icon: 'mdi-chart-box-outline',
          sub: this.$t('onboarding.sub_reports'),
          text: this.$t('onboarding.reports'),
          pathName: 'StudySolutions',
          gtm_mode: 'StudyReports',
          query: { soltab: 'reports' },
          fn: () => {
            this.$store.dispatch('router_update_query', {
              query: { soltab: 'reports' },
              push: false,
            })
          },
        },
      ]
    },
    mobile() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 1023
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  color: var(--clr-primary);
  filter: drop-shadow(1px 0px 6px rgb(0, 172, 141, 0.25));

  fill: currentColor;
  position: absolute;
  // left: calc(50% - 4.5rem);
  // top: calc(50% - 16rem);
  top: calc(50% - 22rem);
  transition: 0.4s;
  &_top {
    top: calc(50% - 27rem) !important;
    animation: flipCard 0.6s ease;
  }
  svg {
    // width: 9rem;
    width: 8rem;
    // width: 6rem;
  }
}
.ob {
  &_title {
    font-size: 2rem;
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-weight: 500;
  }
  &_subtitle {
    font-size: 1rem;
    text-align: center;

    color: var(--clr-grey-2);
    margin-bottom: 2rem;
  }
}
.onboarding-overlay {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  height: var(--vh-100);
  width: 100vw;
  // background: var(--clr-black-0);
  background: linear-gradient(55deg, var(--clr-black-0), var(--clr-black-0-4));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.onb-btn-back {
  position: fixed;
  top: 1rem;
  left: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s;
  &:hover {
    color: var(--clr-grey-2);
  }
}

.grpc {
  &_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    width: 55rem;
  }
  &_btn {
    position: relative;
    border-radius: 8px;
    // border: solid 1px var(--clr-black-3);
    border: solid 2px var(--clr-black-3);
    background: var(--clr-black-1);

    transition: 0.2s;
    cursor: pointer;
    padding: 2rem;
    min-height: 14rem;
    .grpc_icon {
      line-height: 1;
      font-size: 3rem;
    }
    &:hover {
      // background: var(--clr-black-1);
      background: var(--clr-primary-3);

      // border: solid 1px var(--clr-black-1);
      border: solid 2px var(--clr-primary);
      .grpc_icon {
        color: var(--clr-primary);
      }
      // .grpc_icon_hidden {
      //   opacity: 1;
      // }
      .grpc_subtitle {
        // transition: 0.22s;
        // max-height: 5rem;
        opacity: 1;
      }
    }
    // &_open {
    //   padding: 1rem;
    //   display: flex;
    //   align-items: center;
    //   .grpc_icon {
    //     i {
    //       color: var(--clr-primary) !important;
    //     }
    //   }
    //   .grpc_title-box {
    //     position: relative !important;
    //     bottom: unset !important;
    //   }
    // }
  }
  &_title {
    font-size: 1.25rem;
    font-weight: 600;
    text-align: left;
    padding: 0.75rem 0 0 0;
  }
  &_subtitle {
    transition: 0.22s;
    font-weight: 500;
    padding: 0 2rem 0 0;
    font-size: 0.875rem;
    padding: 0.5rem 0 0 0;
    // max-height: 0px;
    // opacity: 0;
  }
}

// @media (max-width: 1024px) {
//   .grpc_btn {
//     padding: 1rem;
//   }
// }
@media (max-width: 777px) {
  // .logo {
  //  display: none;
  // }
  // .ob {
  //   &_title {
  //     text-align: center;
  //   }
  // }
  // .logo {
  //   &_step_2 {
  //     opacity: 0;
  //     transform: scale(0);
  //     animation: none !important;
  //   }
  // }
  .grpc_btn {
    padding: 1rem;
    min-height: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .grpc_title {
      text-align: center;
    }
  }
  .grpc_subtitle {
    display: none;
  }
  .grpc {
    &_grid {
      // text-align: center;
      // grid-template-columns: 1fr;
      // width: 32rem;
      max-width: calc(100vw - 2rem);
    }
  }
}
@media (max-width: 768px) {
  .logo {
    display: none;
  }
}
</style>
